module.exports = __webpack_public_path__ + "img/gb13806_1_a.prt.7508ae38.jpg";